import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { HuwonPage } from './huwon';

@NgModule({
  declarations: [
    HuwonPage,
  ],
  imports: [
    IonicPageModule.forChild(HuwonPage),
  ],
})
export class HuwonPageModule {}



// WEBPACK FOOTER //
// ./src/pages/huwon/huwon.module.ts